import type { Transition } from "motion/react";

/**
 * Named springs. Every animated component should reference one of these
 * instead of hand-rolling stiffness/damping values, so the whole app shares
 * one consistent physical "feel".
 */
export const springs = {
  /** Calm, no overshoot. For chrome that should feel steady (headers, dialogs). */
  gentle: {
    type: "spring",
    stiffness: 260,
    damping: 30,
    mass: 0.9,
  } satisfies Transition,
  /** Slight overshoot, quick settle. For UI elements that should feel alive. */
  snappy: {
    type: "spring",
    stiffness: 420,
    damping: 24,
    mass: 0.7,
  } satisfies Transition,
  /** Pronounced overshoot with a visible settle bounce. For hero moments. */
  bouncy: {
    type: "spring",
    stiffness: 380,
    damping: 15,
    mass: 1,
  } satisfies Transition,
} as const;

export const durations = {
  fast: 0.2,
  base: 0.35,
  slow: 0.6,
} as const;

export const easings = {
  standard: [0.22, 1, 0.36, 1],
  enter: [0.16, 1, 0.3, 1],
  exit: [0.7, 0, 1, 1],
} as const;

/** Standard stagger interval for orchestrated groups (nav buttons, lists). */
export const stagger = {
  tight: 0.05,
  base: 0.07,
  loose: 0.12,
} as const;
